import { render, staticRenderFns } from "./SocialPostsListTable.vue?vue&type=template&id=3977c7ac&scoped=true&"
import script from "./SocialPostsListTable.vue?vue&type=script&lang=js&"
export * from "./SocialPostsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977c7ac",
  null
  
)

export default component.exports